import { AlertProps } from '@cmsgov/design-system/dist/types/Alert/Alert'
import { Alert } from '@cmsgov/ds-medicare-gov'

export type AlertBannerProps = Omit<AlertProps, 'role'>

/**
 * Thin wrapper around the design system alert component so we can have alert with role banner
 * @param props
 * @returns
 */
export const AlertBanner: React.FC<AlertBannerProps> = (props) => {
  return (
    <Alert
      {...props}
      // @ts-ignore
      role='banner'
    />
  )
}
